import { sagas as ledgerSagas } from './modules/ledger'
import { sagas as scheduledChargesSagas } from './modules/scheduledCharges'
import { sagas as customerInvoice } from './modules/customerInvoice'

export default [...ledgerSagas, ...scheduledChargesSagas, ...customerInvoice]
